import Vue from 'vue'
import VueRouter from 'vue-router'
//import store from '@/store'
import Login from '../views/Login'

Vue.use(VueRouter)

// const routes = [
//     {
//       path:'/',
//       name:'login',
//       component: Login,
//     },
//     {
//       path: '/dashboard',
//       name: 'dashboard',
//       component: () => import(/* webpackChunkName:"dashboard"*/"../views/Dashboard"),
//     },
//     {
//       path: '/league/:league_id',
//       name: 'league',
//       props:true,
//       component: () => import("../views/League"),
//     },
//     {
//       path:'/league/:league_id/race-page/:race_id',
//       name:'racePage',
//       component: () => import("../views/RacePage"),
//     },
//     {
//       path:'/user',
//       name:'User',
//       component:()=>import(/* webpaCkchunkName:"user_"*/"../views/User"),
//       // meta:{requireAuth:true}
//     },
//     {
//       path:'/results',
//       name: 'results',
//       component: () => import(/* webpaCkchunkName:"results_"*/"../views/Results"),
//       // meta:{requireAuth:true}
//     },
//     {
//       path:'/tickets',
//       name: 'tickets',
//       component: () => import(/* webpackChunkName:"tickets"*/"../views/Tickets"),
//       // meta:{requireAuth:true}
//     },
//     {
//       path:'/my-cars',
//       name: 'mycars',
//       component: () => import(/* webpackChunkName:"my-cars"*/"../views/MyCars")
//     },
//     {
//       path: '/about',
//       name: 'about',
//       // route level code-splitting
//       // this generates a separate chunk (about.[hash].js) for this route
//       // which is lazy-loaded when the route is visited.
//       component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
//       // meta:{requireAuth:true}
//     }
//   ]

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes:[
    {
    path:'/',
    name:'login',
    component: Login,
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import(/* webpackChunkName:"dashboard"*/"../views/Dashboard"),
      meta: { requiresAuth: true }
    },
    {
      path: '/league/:league_id',
      name: 'league',
      props:true,
      component: () => import("../views/League"),
      meta: { requiresAuth: true }
    },
    {
      path:'/league/:league_id/race-page/:race_id',
      name:'racePage',
      component: () => import("../views/RacePage"),
      meta: { requiresAuth: true }
    },
    {
      path:'/user',
      name:'user',
      component:()=>import(/* webpaCkchunkName:"user_"*/"../views/User"),
      meta: { requiresAuth: true }
    },
    {
      path:'/results',
      name: 'results',
      component: () => import(/* webpaCkchunkName:"results_"*/"../views/Results"),
      meta: { requiresAuth: true }
    },
    {
      path:'/tickets',
      name: 'tickets',
      component: () => import(/* webpackChunkName:"tickets"*/"../views/Tickets"),
      meta: { requiresAuth: true }
    },
    {
      path:'/my-cars',
      name: 'mycars',
      component: () => import(/* webpackChunkName:"my-cars"*/"../views/MyCars"),
      meta: { requiresAuth: true }
    },
    {
      path:'/season-creator',
      name:'seasoncreator',
      component:()=>import(/* webpackChunkName:"my-cars"*/"../views/admin-panel/SeasonCreator"),
      meta: { requiresAuth:true }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
      // meta:{requireAuth:true}
    },
    {
      path:'/404',
      alias:'*',
      name:'notFoud',
      component:()=>import(/*webpakChunkName:"not-found" */ '../views/NotFound.vue'),
    }
]
});
// wyłaczony guard
router.beforeEach((to,from,next)=>{
  const loggedIn = localStorage.getItem('token')

  if(to.matched.some(record => record.meta.requiresAuth && !loggedIn)){
      next('/')
  }
  next()
})  



//stary guard
// router.beforeEnter((to,from,next)=>{
//   var isAuthenticated = false;
//   // if(to.meta.requireAuth){
//     if(store.state.token !=null && store.state.stan==='zalogowano') {
//       isAuthenticated = true;
//     }
//     if(isAuthenticated){
//       next()
//     } else next({ name:'login' });
//   // }
//     // } else{ next({name:'login'})}
// })


export default router
